module.exports = {
    license: "12ff4897-5cb3-4e77-9cdb-25c7ddc4393a",
    fileDataConfig: {
        fields: [
            // 1- Job Information
            {key: "custom_project_id", label: "Project Custom ID",
                validators: [
                    // {
                    // validate: 'required',
                    // error:
                    //     'Project Custom ID is Required.'
                    // },
                    {
                    validate: 'unique',
                    error:
                        'One or more IDs entered is a duplicate.'
                    }
                ]
            },
            {key: "name", label: "Project Name",
                validators: [
                    {
                      validate: 'required',
                      error:
                        'Project Name is Required.'
                    }
                ]
            },
            {key: "address", label: "Address"},
            {key: "city", label: "City"},
            {key: "state", label: "State"},
            {key: "zip", label: "Zip"},
            {key: "contact_name", label: "Project Contact Name"},
            {key: "contact_email", label: "Project Contact Email",
                validators: [
                    {
                        validate: 'regex_matches',
                        // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                        regex : '^\\S+@\\S+$',
                        error: 'Email Must Be Valid'
                    }
                ]
            },
            {key: "contact_phone", label: "Project Contact Phone"},
            {key: "contact_cell", label: "Project Contact Cell"},
            {key: "contact_fax", label: "Project Contact Fax"},
            // 2- Miscellaneous Information
            {key: "sales_status", label: "Sales Status",type: "select",
                options: [
                    { value: "", label: "" }
                ]
            },
            {key: "marketing_status", label: "Marketing Status", type: "select",
                options: [
                    { value: "", label: "" }
                ]
            }, // new value
            {key: "pre_bid_date", label: "Pre Bid",
            // validators: [
            //     {
            //         validate: 'regex_matches',
            //         // regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{4})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{4})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{4})|(02?[-\\/]29?[-\\/](([02468][048]|[13579][26])00|\\d{2}([13579][26]|0[48]|[2468][048]))))$',
            //         regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{4})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{4})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{4})|(2?[-\\/]29?[-\\/](([02468][048]|[13579][26])00|\\d{2}([13579][26]|0[48]|[2468][048]))))$',
            //         error: 'Format Must Be Like m-d-yyyy or m/d/yyyy'
            //     }
            // ]
            }, // new value
            {key: "bid_date", label: "Bid Date",
            // validators: [
            //     {
            //         validate: 'regex_matches',
            //         // regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{4})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{4})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{4})|(02?[-\\/]29?[-\\/](([02468][048]|[13579][26])00|\\d{2}([13579][26]|0[48]|[2468][048]))))$',
            //         regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{4})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{4})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{4})|(2?[-\\/]29?[-\\/](([02468][048]|[13579][26])00|\\d{2}([13579][26]|0[48]|[2468][048]))))$',
            //         error: 'Format Must Be Like m-d-yyyy or m/d/yyyy'
            //     }
            // ]
            },
            {key: "lead_from", label: "Lead From", type:"select",
            options: [
                { value: "", label: "" }
              ]},
            {key: "estimator", label: "Estimator", type:"select",
            options: [
                { value: "", label: "" }
              ]},
            {key: "account_manager", label: "Account Manager", type:"select",
            options: [
                { value: "", label: "" }
              ]},
            {key: "take_off_person", label: "Take Off Person", type:"select",
            options: [
                { value: "", label: "" }
              ]}, // new value
            {key: "products_services", label: "Products & Services" ,type:"select",
            options: [
                { value: "", label: "" }
              ]}, // new value
            {key: "client_profile", label: "Client Profile", type:"select",
            options: [
                { value: "", label: "" }
              ]}, // new value
            {key: "contract_type", label: "Contract Type", type:"select",
            options: [
                { value: "", label: "" }
              ]},
            {key: "office", label: "Office", type:"select",
            options: [
                { value: "", label: "" }
              ]},
            {key: "address1", label: "Address Line 1"},
            {key: "address2", label: "Address Line 2"},
            {key: "full_address", label: "Full Address"},
            // 3- Record Details
            {key: "base_bid", label: "Base Bid",
                // validators: [
                //     {
                //         validate: 'regex_matches',
                //         regex: '^[0-9]+(\\.[0-9]{1,2})?$',
                //         error: 'Upto Two Decimal Value'
                //     }
                // ]
            },
            {key: "contract_amount", label: "Contract Amount",
                // validators: [
                //     {
                //         validate: 'regex_matches',
                //         regex: '^[0-9]+(\\.[0-9]{1,2})?$',
                //         error: 'Upto Two Decimal Value'
                //     }
                // ]
            },
            {key: "gross_margin", label: "Gross Margin %",
                // validators: [
                //     {
                //         validate: 'regex_matches',
                //         regex: '^[0-9]+(\\.[0-9]{1,2})?$',
                //         error: 'Upto Two Decimal Value'
                //     }
                // ]
            }, // new value
            {key: "labor_hours", label: "Labor Hours",
                // validators: [
                //     {
                //         validate: 'regex_matches',
                //         regex: '^[0-9]+(\\.[0-9]{1,2})?$',
                //         error: 'Upto Two Decimal Value'
                //     }
                // ]
            }, // new value//
            {key: "dead_date", label: "Dead Date",
            // validators: [
            //     {
            //         validate: 'regex_matches',
            //         // regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{4})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{4})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{4})|(02?[-\\/]29?[-\\/](([02468][048]|[13579][26])00|\\d{2}([13579][26]|0[48]|[2468][048]))))$',
            //         regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{4})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{4})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{4})|(2?[-\\/]29?[-\\/](([02468][048]|[13579][26])00|\\d{2}([13579][26]|0[48]|[2468][048]))))$',
            //         error: 'Format Must Be Like m-d-yyyy or m/d/yyyy'
            //     }
            // ]
            }, // new value
            {key: "login_date", label: "Login Date"},
            {key: "contract_date", label: "Contract Date",
            // validators: [
            //     {
            //         validate: 'regex_matches',
            //         // regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{4})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{4})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{4})|(02?[-\\/]29?[-\\/](([02468][048]|[13579][26])00|\\d{2}([13579][26]|0[48]|[2468][048]))))$',
            //         regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{4})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{4})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{4})|(2?[-\\/]29?[-\\/](([02468][048]|[13579][26])00|\\d{2}([13579][26]|0[48]|[2468][048]))))$',
            //         error: 'Format Must Be Like m-d-yyyy or m/d/yyyy'
            //     }
            // ]
            },
            // 4- Handled at backend entity
            // {key: "proposal_delivered", label: "Proposal Delivered",
            // validators: [
            //     {
            //         validate: 'regex_matches',
            //         // regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{4})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{4})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{4})|(02?[-\\/]29?[-\\/](([02468][048]|[13579][26])00|\\d{2}([13579][26]|0[48]|[2468][048]))))$',
            //         regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{4})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{4})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{4})|(2?[-\\/]29?[-\\/](([02468][048]|[13579][26])00|\\d{2}([13579][26]|0[48]|[2468][048]))))$',
            //         error: 'Format Must Be Like m-d-yyyy or m/d/yyyy'
            //     }
            // ]
            // },
            {key: "project_comments", label: "Project Comment"},
            {key: "company_name_1", label: "Company Name 1"},
            {key: "company_phone_1", label: "Company Phone 1"},
            {key: "company_contact_name_1", label: "Company Contact Name 1"},
            {key: "company_contact_title_1", label: "Company Contact Title 1"},
            {key: "company_contact_email_1", label: "Company Contact Email 1",
                // validators: [
                //     {
                //         validate: 'regex_matches',
                //         // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                //         regex : '^\\S+@\\S+$',
                //         error: 'Email Must Be Valid'
                //     }
                // ]
            },
            {key: "company_contact_phone_1", label: "Company Contact Phone 1"},
            {key: "followup_1", label: "Followup 1",
            // validators: [
            //         {
            //             validate: 'regex_matches',
            //             regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{2})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{2})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{2})|(2?[-\\/]29?[-\\/]([13579][26]|0[48]|[2468][048]))) (([0-9]|1[0-2])\\:([012345][0-9])\\s(A|P)M)$',
            //             error: 'Format Must Be Like m-d-yy h:mm AM/PM or m/d/yy h:mm AM/PM'
            //         }
            //     ]
            },
            {key: "status_1", label: "Status 1", type: "select",
                options: [
                    { value: "", label: "" }
                ]
            },
            {key: "company_name_2", label: "Company Name 2"},
            {key: "company_phone_2", label: "Company Phone 2"},
            {key: "company_contact_name_2", label: "Company Contact Name 2"},
            {key: "company_contact_title_2", label: "Company Contact Title 2"},
            {key: "company_contact_email_2", label: "Company Contact Email 2",
                validators: [
                    {
                        validate: 'regex_matches',
                        // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                        regex : '^\\S+@\\S+$',
                        error: 'Email Must Be Valid'
                    }
                ]
            },
            {key: "company_contact_phone_2", label: "Company Contact Phone 2"},
            {key: "followup_2", label: "Followup 2",
                // validators: [
                //     {
                //         validate: 'regex_matches',
                //         regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{2})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{2})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{2})|(2?[-\\/]29?[-\\/]([13579][26]|0[48]|[2468][048]))) (([0-9]|1[0-2])\\:([012345][0-9])\\s(A|P)M)$',
                //         error: 'Format Must Be Like m-d-yy h:mm AM/PM or m/d/yy h:mm AM/PM'
                //     }
                // ]
            },
            {key: "status_2", label: "Status 2", type: "select",
                options: [
                    { value: "", label: "" }
                ]
            },
            {key: "company_name_3", label: "Company Name 3"},
            {key: "company_phone_3", label: "Company Phone 3"},
            {key: "company_contact_name_3", label: "Company Contact Name 3"},
            {key: "company_contact_title_3", label: "Company Contact Title 3"},
            {key: "company_contact_email_3", label: "Company Contact Email 3",
                validators: [
                    {
                        validate: 'regex_matches',
                        // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                        regex : '^\\S+@\\S+$',
                        error: 'Email Must Be Valid'
                    }
                ]
            },
            {key: "company_contact_phone_3", label: "Company Contact Phone 3"},
            {key: "followup_3", label: "Followup 3",
                // validators: [
                //     {
                //         validate: 'regex_matches',
                //         regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{2})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{2})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{2})|(2?[-\\/]29?[-\\/]([13579][26]|0[48]|[2468][048]))) (([0-9]|1[0-2])\\:([012345][0-9])\\s(A|P)M)$',
                //         error: 'Format Must Be Like m-d-yy h:mm AM/PM or m/d/yy h:mm AM/PM'
                //     }
                // ]
            },
            {key: "status_3", label: "Status 3", type: "select",
                options: [
                    { value: "", label: "" }
                ]
            },
            {key: "company_name_4", label: "Company Name 4"},
            {key: "company_phone_4", label: "Company Phone 4"},
            {key: "company_contact_name_4", label: "Company Contact Name 4"},
            {key: "company_contact_title_4", label: "Company Contact Title 4"},
            {key: "company_contact_email_4", label: "Company Contact Email 4",
                validators: [
                    {
                        validate: 'regex_matches',
                        // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                        regex : '^\\S+@\\S+$',
                        error: 'Email Must Be Valid'
                    }
                ]
            },
            {key: "company_contact_phone_4", label: "Company Contact Phone 4"},
            {key: "followup_4", label: "Followup 4",
                // validators: [
                //     {
                //         validate: 'regex_matches',
                //         regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{2})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{2})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{2})|(2?[-\\/]29?[-\\/]([13579][26]|0[48]|[2468][048]))) (([0-9]|1[0-2])\\:([012345][0-9])\\s(A|P)M)$',
                //         error: 'Format Must Be Like m-d-yy h:mm AM/PM or m/d/yy h:mm AM/PM'
                //     }
                // ]
            },
            {key: "status_4", label: "Status 4", type: "select",
                options: [
                    { value: "", label: "" }
                ]
            },
            {key: "company_name_5", label: "Company Name 5"},
            {key: "company_phone_5", label: "Company Phone 5"},
            {key: "company_contact_name_5", label: "Company Contact Name 5"},
            {key: "company_contact_title_5", label: "Company Contact Title 5"},
            {key: "company_contact_email_5", label: "Company Contact Email 5",
                validators: [
                    {
                        validate: 'regex_matches',
                        // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                        regex : '^\\S+@\\S+$',
                        error: 'Email Must Be Valid'
                    }
                ]
            },
            {key: "company_contact_phone_5", label: "Company Contact Phone 5"},
            {key: "followup_5", label: "Followup 5",
                // validators: [
                //     {
                //         validate: 'regex_matches',
                //         regex: '^(((1|3|5|7|8|10|12)?[-\\/]([1-9]|1[0-9]|2[0-9]|3[01])?[-\\/]\\d{2})|((4|6|9|11)?[-\\/]([1-9]|1[0-9]|2[0-9]|30)?[-\\/]\\d{2})|(2?[-\\/]([1-9]|1[0-9]|2[0-8])?[-\\/]\\d{2})|(2?[-\\/]29?[-\\/]([13579][26]|0[48]|[2468][048]))) (([0-9]|1[0-2])\\:([012345][0-9])\\s(A|P)M)$',
                //         error: 'Format Must Be Like m-d-yy h:mm AM/PM or m/d/yy h:mm AM/PM'
                //     }
                // ]
            },
            {key: "status_5", label: "Status 5", type: "select",
                options: [
                    { value: "", label: "" }
                ]
            }
        ],
        i18nOverrides: {
            en: {
              otherLocales: ["en-US", "en-CA", "en-GB"],
              overrides: {
                header: "Bulk add {{number}} Project Data",
              }
            }
        },
        styleOverrides: {
            primaryButtonColor: "#01b1af",
            primaryTextColor: "#01b1af"
        },
        type: "Project Data",
        managed: true,
        // allowInvalidSubmit:true,
        encoding: 'utf-8',
    },
    clientsConfig: {
        fields: [
            {key: "name", label: "Company Name",
            validators: [
                {
                  validate: 'required',
                  error:
                    'Company Name is Required.'
                }
              ]},
            {key: "address", label: "Address"},
            {key: "address1", label: "Address Line 1"},
            {key: "address2", label: "Address Line 2"},
            {key: "full_address", label: "Full Address"},
            {key: "city", label: "City"},
            {key: "state", label: "State"},
            {key: "zip", label: "Zip"
            // validators: [
            //     {
            //         validate: 'regex_matches',
            //         regex: '^[0-9]*$',
            //         error: 'Must Be Numeric'
            //     }
            //   ]
            },
            {key: "phone", label: "Phone"},
            {key: "fax", label: "Fax"},
            {key: "site", label: "Web Site"},
            {key: "company_type", label: "Company Type",type: "select",
            options:[
                {value: "", label: ""}
            ]},
            {key: "company_status", label: "Company Status", type: "select",
                options: [
                    { value: "", label: "" }
                ]
            },
            {key: "company_notes", label: "Company Notes"},
            {key: "parent_company", label: "Parent Company"},
            // 01
            {key: "contact_name_1", label: "Contact Name 1"},
            {key: "contact_cell_1", label: "Contact Cell 1"},
            {key: "contact_email_1", label: "Contact Email 1",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_1", label: "Contact Title 1"},
            // 02
            {key: "contact_name_2", label: "Contact Name 2"},
            {key: "contact_cell_2", label: "Contact Cell 2"},
            {key: "contact_email_2", label: "Contact Email 2",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_2", label: "Contact Title 2"},
            // 03
            {key: "contact_name_3", label: "Contact Name 3"},
            {key: "contact_cell_3", label: "Contact Cell 3"},
            {key: "contact_email_3", label: "Contact Email 3",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_3", label: "Contact Title 3"},
            // 04
            {key: "contact_name_4", label: "Contact Name 4"},
            {key: "contact_cell_4", label: "Contact Cell 4"},
            {key: "contact_email_4", label: "Contact Email 4",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_4", label: "Contact Title 4"},
            // 05
            {key: "contact_name_5", label: "Contact Name 5"},
            {key: "contact_cell_5", label: "Contact Cell 5"},
            {key: "contact_email_5", label: "Contact Email 5",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_5", label: "Contact Title 5"},
            // 06
            {key: "contact_name_6", label: "Contact Name 6"},
            {key: "contact_cell_6", label: "Contact Cell 6"},
            {key: "contact_email_6", label: "Contact Email 6",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_6", label: "Contact Title 6"},
            // 07
            {key: "contact_name_7", label: "Contact Name 7"},
            {key: "contact_cell_7", label: "Contact Cell 7"},
            {key: "contact_email_7", label: "Contact Email 7",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_7", label: "Contact Title 7"},
            // 08
            {key: "contact_name_8", label: "Contact Name 8"},
            {key: "contact_cell_8", label: "Contact Cell 8"},
            {key: "contact_email_8", label: "Contact Email 8",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_8", label: "Contact Title 8"},
            // 09
            {key: "contact_name_9", label: "Contact Name 9"},
            {key: "contact_cell_9", label: "Contact Cell 9"},
            {key: "contact_email_9", label: "Contact Email 9",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_9", label: "Contact Title 9"},
            // 10
            {key: "contact_name_10", label: "Contact Name 10"},
            {key: "contact_cell_10", label: "Contact Cell 10"},
            {key: "contact_email_10", label: "Contact Email 10",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_10", label: "Contact Title 10"},
            // 11
            {key: "contact_name_11", label: "Contact Name 11"},
            {key: "contact_cell_11", label: "Contact Cell 11"},
            {key: "contact_email_11", label: "Contact Email 11",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_11", label: "Contact Title 11"},
            // 12
            {key: "contact_name_12", label: "Contact Name 12"},
            {key: "contact_cell_12", label: "Contact Cell 12"},
            {key: "contact_email_12", label: "Contact Email 12",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_12", label: "Contact Title 12"},
            // 13
            {key: "contact_name_13", label: "Contact Name 13"},
            {key: "contact_cell_13", label: "Contact Cell 13"},
            {key: "contact_email_13", label: "Contact Email 13",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_13", label: "Contact Title 13"},
            // 14
            {key: "contact_name_14", label: "Contact Name 14"},
            {key: "contact_cell_14", label: "Contact Cell 14"},
            {key: "contact_email_14", label: "Contact Email 14",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_14", label: "Contact Title 14"},
            // 15
            {key: "contact_name_15", label: "Contact Name 15"},
            {key: "contact_cell_15", label: "Contact Cell 15"},
            {key: "contact_email_15", label: "Contact Email 15",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_15", label: "Contact Title 15"},
            // 16
            {key: "contact_name_16", label: "Contact Name 16"},
            {key: "contact_cell_16", label: "Contact Cell 16"},
            {key: "contact_email_16", label: "Contact Email 16",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_16", label: "Contact Title 16"},
            // 17
            {key: "contact_name_17", label: "Contact Name 17"},
            {key: "contact_cell_17", label: "Contact Cell 17"},
            {key: "contact_email_17", label: "Contact Email 17",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_17", label: "Contact Title 17"},
            // 18
            {key: "contact_name_18", label: "Contact Name 18"},
            {key: "contact_cell_18", label: "Contact Cell 18"},
            {key: "contact_email_18", label: "Contact Email 18",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_18", label: "Contact Title 18"},
            // 19
            {key: "contact_name_19", label: "Contact Name 19"},
            {key: "contact_cell_19", label: "Contact Cell 19"},
            {key: "contact_email_19", label: "Contact Email 19",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_19", label: "Contact Title 19"},
            // 20
            {key: "contact_name_20", label: "Contact Name 20"},
            {key: "contact_cell_20", label: "Contact Cell 20"},
            {key: "contact_email_20", label: "Contact Email 20",
            validators: [
                {
                    validate: 'regex_matches',
                    // regex : '^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$',
                    regex : '^\\S+@\\S+$',
                    error: 'Email Must Be Valid'
                }
              ]},
            {key: "contact_title_20", label: "Contact Title 20"}
        ],
        styleOverrides: {
            primaryButtonColor: "#01b1af",
            primaryTextColor: "#01b1af"
        },
        type: "Companies",
        managed: true,
        // allowInvalidSubmit:true,
        encoding: 'utf-8',
    },
    contactsConfig: {
        fields: [
            {key: "name", label: "Contact Name",
                validators: [{
                    validate: 'required',
                    error:'Contact Name is Required.'
                }]
            },
            {key: "company_name", label: "Company Name"},
            {key: "cell", label: "Cell"},
            {key: "email", label: "Email",
                validators: [
                    {
                        validate: 'regex_matches',
                        regex : '^\\S+@\\S+$',
                        error: 'Email must Be valid'
                    }
                ]},
            {key: "title", label: "Title"},
            {key: "contact_type", label: "Contact Type",
                type: "select",
                options:[
                    {value: "", label: ""}
                ]
            },
            {key: "followup", label: "Follow Up"},
            {key: "user", label: "User",
                type: "select",
                options:[
                    {value: "", label: ""}
                ]
            },
            {key:"address", label: "Address"},
            {key:"city", label: "City" },
            {key:"state", label: "State" },
            {key:"zip", label: "Zip" },
            {key: "contact_note", label: "Contact Notes"},
        ],
        styleOverrides: {
            primaryButtonColor: "#01b1af",
            primaryTextColor: "#01b1af"
        },
        title: "Bulk add Contacts",
        type: "Contacts",
        managed: true,
        encoding: 'utf-8',
    },
    projectConfig:{
        fields: [
            {key: "base_bid", label: "Base bid"},
            {key: "contract_amount", label: "Contract Amount"},
            {key: "gross_margin", label: "Gross Margin"},
            {key:"labor_hours", label: "Labour Hours"},
        ],
        styleOverrides: {
            primaryButtonColor: "#01b1af",
            primaryTextColor: "#01b1af"
        },
        type: "Projects",
        managed: true,
        encoding: 'utf-8',
    }
};
